import AreaCode from '@/utils/phone.json'
import { check_userName, check_Number, check_Mail, SortAreaCode } from '@/libs/form'
import { inserSeoElement } from '@/libs/utils'
const mixin = {
    name: 'Office',
    data() {
        return {
            office_imgs: [
                require('@/assets/office_building.webp'),
                require('@/assets/office_boat1.webp'),
                require('@/assets/office_boat2.webp'),
                require('@/assets/office_boat3.webp'),
            ],
            temp: {
                name: '',
                email: '',
                qz: '',
                phone: '',
                message: '',
            },
            rules: {},
            areaCode: AreaCode,
            commitStatus: false,
        }
    },

    methods: {
        office_submit() {
            // console.log(this.temp);
        },
        commit() {
            let { name, phone, email, message, qz } = this.temp
            if (name === '' || name.length > 64) {
                return this.$message.warning(this.$t('form.nameCheck'))
            }
            if (phone == '' || phone.length + qz.length > 20 || phone.length + qz.length < 6 || !check_Number(phone)) {
                return this.$message.warning(this.$t('form.phoneCheck'))
            }
            if (qz === '') {
                return this.$message.warning(this.$t('form.qzCheck'))
            }
            if (email === '' || !check_Mail(email)) {
                return this.$message.warning(this.$t('form.emailCheck'))
            }
            if (message === '') {
                return this.$message.warning(this.$t('form.messageBoard'))
            }
            if (this.commitStatus) return
            this.commitStatus = true
            let data = {
                name,
                areaCode: qz,
                mobile: phone,
                message,
                email,
            }
            this.$store
                .dispatch('sendContactMsg', data)
                .then(() => {
                    this.commitStatus = false
                    Object.keys(this.temp).forEach(item => {
                        this.$set(this.temp, item, '')
                    })
                })
                .catch(() => {
                    this.commitStatus = false
                })
        },
    },

    computed: {
        contacts1() {
            return [
                {
                    img: require('@/assets/icon_mobile.webp'),
                    name: this.$t('booking_hotline'),
                    val: this.$store.state.baseConfig.baseConfigInfo.serviceMobileList[0],
                },
                {
                    img: require('@/assets/icon_phone.webp'),
                    name: 'WHATSAPP',
                    val: this.$store.state.baseConfig.baseConfigInfo.whatsAppAccount,
                },
                {
                    img: require('@/assets/icon_email.webp'),
                    name: this.$t('booking') + '/' + this.$t('sales_enquiry'),
                    val: this.$store.state.baseConfig.baseConfigInfo.bookingAndSalesEnquiryEmail,
                },
                {
                    img: require('@/assets/icon_email.webp'),
                    name: this.$t('marketing_enquiry'),
                    val: this.$store.state.baseConfig.baseConfigInfo.marketingEnquiryEmail,
                },
                {
                    img: require('@/assets/icon_email.webp'),
                    name: this.$t('career_opportunity'),
                    val: this.$store.state.baseConfig.baseConfigInfo.careerOpportunityEmail,
                },
                {
                    img: require('@/assets/icon_email.webp'),
                    name: this.$t('complaints') + '/' + this.$t('feedback'),
                    val: this.$store.state.baseConfig.baseConfigInfo.complaintsAndFeedbackEmail,
                },
            ]
        },
        contacts2() {
            return [
                {
                    img: require('@/assets/icon-location.webp'),
                    name: this.$t('office_address'),
                    val: this.$store.state.baseConfig.baseConfigInfo.officeAddress,
                },
                {
                    img: require('@/assets/location.webp'),
                    name: this.$t('location_pin'),
                    val: this.$store.state.baseConfig.baseConfigInfo.officeAddressLink,
                },
                {
                    img: require('@/assets/clock.webp'),
                    name: this.$t('office_hours'),
                    val: this.$store.state.baseConfig.baseConfigInfo.officeTime,
                },
            ]
        },
        contacts3() {
            return [
                {
                    img: require('@/assets/icon-location.webp'),
                    name: this.$t('address'),
                    val: this.$store.state.baseConfig.baseConfigInfo.sentryBoxAddress,
                },
                {
                    img: require('@/assets/location.webp'),
                    name: this.$t('directions'),
                    val: this.$store.state.baseConfig.baseConfigInfo.sentryBoxAddressLink,
                },
                {
                    img: require('@/assets/icon_mobile.webp'),
                    name: this.$t('booking_hotline'),
                    val: this.$store.state.baseConfig.baseConfigInfo.serviceMobileList[0],
                },
                {
                    img: require('@/assets/icon_phone.webp'),
                    name: 'WHATSAPP',
                    val: this.$store.state.baseConfig.baseConfigInfo.whatsAppAccount,
                },
            ]
        },
    },
    mounted() {
        inserSeoElement(this.$t('headSeo.contactTitle'), this.$t('headSeo.contactKey'), this.$t('headSeo.contactDec'))
    },
}

export default mixin
